import { z } from 'zod'
import { Currency } from '../../enums/currency.enum'
import { PaymentType } from '../../enums/payment-type.enum'

export const createExpenseTemplateSchema = z.object({
  name: z.string().min(1).max(100),
  amount: z.number().positive().optional(),
  currency: z.nativeEnum(Currency).optional(),
  description: z.string().max(500).optional(),
  paymentType: z.nativeEnum(PaymentType).optional(),
  accountId: z.string().guid().optional(),
  categoryId: z.string().guid().optional(),
  groupId: z.string().guid().nullish(),
})

export type CreateExpenseTemplateDto = z.infer<typeof createExpenseTemplateSchema>
